import { Component } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "../../hooks/useTranslation";

class FooterComponent extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { currentLanguage } = this.props;
    const contactLink = this.props.getPathWithLanguage ? this.props.getPathWithLanguage("/kontakt", currentLanguage) : "/kontakt";
    
    return (
      <div className="footer">
        <Link to={contactLink} aria-label="Kontakt">
          <div className="contact_icon_footer"></div>
        </Link>
      </div>
    );
  }
}

// Wrapper component with hooks
export const Footer = (props) => {
  const { currentLanguage, getPathWithLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <FooterComponent 
      {...props} 
      currentLanguage={currentLanguage}
      getPathWithLanguage={getPathWithLanguage}
      t={t}
    />
  );
};
